export default {
    urlBase: 'https://ingresosolicitudes.dentistacontralor.cl/'
    //urlBase: 'http://localhost:8000/'
}



// WEBPACK FOOTER //
// ./src/config/index.js